import { useSetRecoilState } from 'recoil'

import { loadingStore } from './useLoadingStore'

const useManageProjectAction = () => {
    const setLoadingStore = useSetRecoilState(loadingStore)

    const openLoading = () => {
        setLoadingStore((prevState) => ({
            ...prevState,
            isLoading: true,
        }))
    }

    const closeLoading = () => {
        setLoadingStore((prevState) => ({
            ...prevState,
            isLoading: false,
        }))
    }
    return { openLoading, closeLoading }
}

export default useManageProjectAction
